import { fillSegments } from 'modules/route/route';
import { useCallback, useRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useWidgets } from 'state/widget/widget';
import { QueryParam } from 'consts/keys';
import { useFeatureFlags } from 'contexts/FeatureFlagsContext';
import { FeatureFlagId } from 'types/featureflags';
import { filterSearchParams } from 'utils/routeUtils';
import { ROUTES, Segments } from './Views/routes';

const SEARCH_PARAMS_TO_PRESERVE = [QueryParam.TenantId, QueryParam.CookieName];

export const useNav = () => {
	const navigate = useNavigate();
	const navigateRef = useRef(navigate);
	navigateRef.current = navigate;
	const [searchParams] = useSearchParams();
	const { isFeatureFlagActive } = useFeatureFlags();
	const preserveQueryParamsEnabled = isFeatureFlagActive(
		FeatureFlagId.PRESERVE_QUERY_PARAMS
	);

	return useCallback(
		(route: string) => {
			let search = '';
			if (preserveQueryParamsEnabled) {
				const preservedSearchParams = filterSearchParams(
					searchParams,
					SEARCH_PARAMS_TO_PRESERVE
				);
				const preservedStr = preservedSearchParams.toString();
				search = preservedStr ? `?${preservedStr}` : '';
			}
			navigateRef.current(`${route}${search}`);
		},
		[searchParams, preserveQueryParamsEnabled]
	);
};

export const useNavigateToFirstWidget = () => {
	const widgets = useWidgets();
	const navigate = useNav();

	return useCallback(() => {
		/* istanbul ignore next */
		if (!widgets?.length) {
			return;
		}

		navigate(
			fillSegments(ROUTES.widget, {
				[Segments.WidgetPath]: widgets[0].path
			})
		);
	}, [navigate, widgets]);
};
